import type { AppDB } from '../db';
import { Entity } from 'dexie';

class Unit extends Entity<AppDB> {
  public uid!: number;
  public uid_parent!: number;
  public tag!: string;
  public editable!: boolean;

  public get label() {
    return this.tag;
  }
}

export default Unit;
